// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"dba-z","colorTextValue":"eba-z","swatches":"fba-z","collapseLink":"gba-z","isCollapsed":"hba-z","dropdown":"iba-z","disabled":"jba-z"};